module.exports = __webpack_public_path__ + "db45eacd033e7de6228bb8d7d3d6690e.pdf";